import SSOFailed from './SSOFailed'

export default SSOFailed
